import React from "react";
import CloseRounded from "@mui/icons-material/CloseRounded";
import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
} from "@mui/material";

const Modal = ({
  title,
  openModal,
  setOpenModal,
  action,
  customClass,
  children,
  showCloseIcon = true,
  parentStyle
}) => {
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpenModal(false);
    }
  };

  return (
    <Dialog
      onClose={handleClose}
      open={openModal}
      className={customClass}
      sx={{zIndex: 777777777777777}}
      BackdropProps={{ onClick: (e) => e.stopPropagation() }}
    >
      {title && (
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="customized-dialog-title"
          fontWeight={400}
          style={{ textAlign: "center" }}
        >
          {title}
        </DialogTitle>
      )}
      {showCloseIcon && (
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "black",
          }}
        >
          <CloseRounded />
        </IconButton>
      )}
      <DialogContent>{children}</DialogContent>
      {/* {!!action && <DialogActions>{action}</DialogActions>} */}
    </Dialog>
  );
};

export default Modal;